<template>
    <div class="wrap">
        <div class="top" :style="{backgroundImage: `url(${background})`}" >
            <router-link :class="['cover', {'no-click': showCheckbox}]" :to="{ path: '/user/play/', query: { videoId: video.id, date: this.date, device: this.device }}" target="_blank">
                <i class="icon-icon_play-video"></i>
            </router-link>
            <div :class="['cover', 'video-handler-cover', {'no-click': !showCheckbox}]">
                <div class="video-handler">
                    <span class="icon-icon_download" @click="downLoadVideo(video.id)"></span>
                    <span class="icon-bin-line" @click="deleting = true"></span>
                </div>
            </div>
            <checkbox class="video-checkbox" type="fill" v-model="videoSelected" v-show="showCheckbox" @click="selectHandle"/>
            <p class="device" :title="deviceObj[ video.uid ]">{{ deviceObj[ video.uid ] }}</p>
        </div>
        <div class="bottom">
            <div class="show-on-pc">
                <p class="time" :title="video.title || time.time">{{video.title || time.time}}</p>
                <p class="day">{{time.day}} {{time.time}} | {{size}}</p>
            </div>
            <div class="show-on-mobile">
                <p class="time" :title="video.title || time.time">{{video.title || time.time}}</p>
                <p class="size">{{size}}</p>
            </div>
        </div>
        <confirm-dialog @confirmAction="deleteVideo" v-if="deleting"></confirm-dialog>
        <span v-if="expiration < 4" class="remaining-time">
            <i class="icon-icon_clock"></i>
            <span v-if="expiration === 0">&lt; 1d</span>
            <span v-else>{{ expiration }}d</span>
        </span>
    </div>
</template>

<script>
import Checkbox from '@/basic/Checkbox';
import { timeResolve } from '@/common/js/date';
import { deleteVideo, downloadVideo } from '@/api/cloud';
import confirmDialog from '@/basic/confirmDialog';
import defaultCover from 'IMAGE/cloud/default-cover.jpg';
import initBg from '@/common/js/defaultBg';

export default {

    components: {

        Checkbox,
        confirmDialog

    },

    created () {

        initBg( this, `${this.video.coverUrl}small.jpg` );

    },

    data () {

        return {

            videoSelected: this.video.checked,
            deleting: false,
            background: `${this.video.coverUrl}small.jpg`,
            defaultBg: defaultCover

        };

    },

    props: {

        video: Object,
        showCheckbox: {

            type: Boolean,
            default () {

                return false;

            }

        },
        deviceObj: {

            type: Object,
            default () {

                return {};

            }
        },
        index: Number,
        date: String,
        device: String

    },

    methods: {

        selectHandle ( checked ) {

            this.$emit( 'selectHandle', {

                index: this.index,
                checked

            });

        },

        downLoadVideo ( id ) {

            downloadVideo( id ).then( suc => {
            }).catch( err => {

                this.$store.dispatch( 'topInfoToggle', {

                    type: 'error',
                    msgIndex: 'errors.download_video'

                });
                console.error( err );

            });

        },

        deleteVideo ( flag ) {

            if ( flag ) {

                let id = this.video.id;
                deleteVideo( [ id ] ).then( res => {

                    this.$emit( 'delete', [ id ] );
                    this.$store.dispatch( 'topInfoToggle', {

                        type: 'success',
                        msgIndex: 'suc.delete_video'

                    });

                }).catch( err => {

                    this.$store.dispatch( 'topInfoToggle', {

                        type: 'error',
                        msgIndex: 'errors.delete_video'

                    });
                    console.error( err );

                });

            }

            this.deleting = false;

        }

    },

    computed: {

        time () {

            let timeStamp = this.video.createdAt;
            let obj = {

                day: '',
                time: ''

            };
            if ( !timeStamp ) {

                return obj;

            }
            let {

                year,
                month,
                dateOfMonth,
                hourOf12Decimal: hour,
                noon,
                minute,
                second

            } = timeResolve( timeStamp );
            obj.time = `${hour}:${minute}:${second} ${noon}`;
            obj.day = `${dateOfMonth}/${month}/${year}`;
            return obj;

        },

        size () {

            let size = this.video.size;
            return `${Number( size / ( 1024 * 1024 )).toFixed( 2 )}MB`;

        },

        selected () {

            return this.video.checked;

        },

        currentUrl () {

            return `${this.video.coverUrl}small.jpg`;

        },

        expiration () {

            let { expiredAt } = this.video;
            let now = new Date().getTime();
            return Math.floor(( expiredAt - now ) / 86400 / 1000 );

        }

    },

    watch: {

        selected ( selected ) {

            this.videoSelected = selected;

        },

        'video.coverUrl': {

            handler ( cover ) {

                initBg( this, `${cover}small.jpg` );

            },
            deep: true

        }

    }

};
</script>

<style scoped lang="less">
    .wrap {
        width: 270px;
        display: inline-block;
        box-shadow: 0px 0px 22px rgba(0,0,0,0.2);
        border-radius: 0.1rem;
        margin: 0.2rem;
        position: relative;
    }
    @media screen and (min-width:1200px) {
        .wrap:nth-child(4n+1) {
            margin-left: 0;
        }
        .wrap:nth-child(4n+4) {
            margin-right: 0;
        }
    }
    @media screen and (max-width:1023px) and (min-width:751px) {
        .wrap:nth-child(3n+1) {
            margin-left: 0;
        }
        .wrap:nth-child(3n+3) {
            margin-right: 0;
        }
    }
    .top {
        height: 1.44rem;
        position: relative;
        border-radius: 0.1rem 0.1rem 0 0;
        background-size: cover;
        z-index: 0;
    }
    .bottom {
        background-color: #fff;
        padding: 0.15rem;
        border-radius: 0 0 0.1rem 0.1rem;
        box-sizing: border-box;
        text-align: left;
    }
    .no-click.cover{
        display: none !important;
    }
    .cover {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgb(0, 0, 0);
        border-radius: 0.1rem 0.1rem 0 0;
        z-index: 2;
        opacity: 0;
        transition: background-color 0.35s ease, opacity 0.35s ease;
        cursor: pointer;
    }
    @media screen and (min-width:1200px){
        .cover:hover {
            opacity: 1;
            background-color: rgba(0,0,0,0.3);
        }
    }
    .device {
        position: absolute;
        padding: 0.2rem 0.1rem 0.05rem 0;
        bottom: 0;
        width: 100%;
        font-weight: 500;
        color: #fff;
        font-size: 0.14rem;
        box-sizing: border-box;
        text-align: right;
        background: -webkit-linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 100%);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .cover>i {
        font-size: 0.25rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
    }
    .time {
        font-weight: 500;
        font-size: 0.16rem;
        color: #333;
        margin-bottom: 0.02rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .day {
        font-size: 0.14rem;
        color: #595757;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .video-checkbox{
        position: absolute;
        right: 0.1rem;
        top: 0.1rem;
        z-index: 3;
    }
    .video-handler{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        text-align: center;
    }
    .video-handler span{
        background-color: #fff;
        border-radius: 100%;
        width: 0.44rem;
        height: 0.44rem;
        box-sizing: border-box;
        cursor: pointer;
        display: inline-block;
        position: relative;
    }
    .bottom .show-on-mobile{
        display: none;
    }
    .video-handler span:last-child{
        margin-left: 0.2rem;
    }
    .video-handler .icon-icon_download:before,
    .video-handler .icon-bin-line:before{
        font-size: 0.24rem;
        color: #333;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }
    .video-handler .icon-icon_download:hover:before,
    .video-handler .icon-bin-line:hover:before{
        color: @theme;
    }
    .remaining-time{
        position: absolute;
        left: 0;
        top: 0.1rem;
        color: #fff;
        font-size: 0.16rem;
        font-weight: 500;
        background-color: #D94429;
        padding: 0 0.1rem;
        line-height: 0.24rem;
        border-top-right-radius: 0.03rem;
        border-bottom-right-radius: 0.03rem;
        i{
            font-size: 0.12rem;
        }
    }
    @media @mobile{
        .remaining-time{
            font-size: 0.2rem;
            padding: 0.05rem 0.1rem;
            border-top-right-radius: 0.05rem;
            border-bottom-right-radius: 0.05rem;
            span{
                line-height: 1;
                vertical-align: top;
            }
            i{
                font-size: 0.16rem;
            }
        }
    }
    @media screen and (max-width:1199px){
        .bottom .show-on-pc{
            display: none;
        }
        .bottom .show-on-mobile{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .bottom .show-on-mobile .time{
            flex-grow: 1;
            margin-right: 0.1rem;
            margin-bottom: 0;
        }
        .size{
            font-size: 0.26rem;
        }
        .wrap{
            width: calc(50% - 5px);
            margin: 0 0 0.24rem 0;
        }
        .top{
            height: calc((50vw - 20px) * 0.533);
        }
        .time{
            font-size: 0.28rem;
        }
        .day{
            font-size: 0.2rem;
        }
        .video-handler-cover{
            display: none;
        }
        .device{
            font-size: 0.24rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/VideoListItem.vue